// frontend/src/lib/sessionLength.ts
// What a session costs a player, stated in one place.
//
// The Guide told players a case ran "roughly 45 to 60 minutes" for as long as
// it took someone to notice that migration 012 had cut the default argument
// clock from thirty minutes to five. The figure was prose, nothing tied it to
// the clock, and prose does not fail a test. So the numbers the app states
// live here, and `tests/test_api/test_stated_session_length.py` fails if the
// argument clock stops matching DEFAULT_TIME_LIMIT_SECONDS in
// `src/db/queries/account.py`, which is the value a new account is actually
// given.

/** The argument clock a new account gets, in minutes.
 *
 *  Pinned to `DEFAULT_TIME_LIMIT_SECONDS` (300) in
 *  `src/db/queries/account.py`. A player can set anything from 5 to 60 in
 *  Settings; this is what they start with and what the landing page promises.
 */
export const DEFAULT_ARGUMENT_MINUTES = 5;

/** What a whole case costs, from the curtain to the written opinion.
 *
 *  A ceiling, not an average, and stated as one so it can only be a pleasant
 *  surprise. Nothing in the code bounds it: the argument clock is the only
 *  timed phase, and the conference, the deliberation and the opinion end when
 *  the models finish rather than on a clock (`configs/timing.yaml` configures
 *  no duration for them, and `_sub_phase_seconds` returns 0 outside the
 *  argument). So the number comes from measurement, and every complete
 *  session anyone has timed comes in under it:
 *
 *    t10, two complete sessions on this build: "took under three minutes in
 *      my leanest run and under six minutes with a fuller six-exchange
 *      argument"
 *    t8, four cases: "The floor per case is about seven minutes"
 *    t7, sitting through the whole conference rather than skipping it:
 *      a 5:00 argument plus about six minutes of deliberation
 *
 *  Raise it if the conference ever stops being skippable, and lower it when
 *  someone times a slow run properly.
 */
export const SESSION_MINUTES_CEILING = 15;
